// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { upperCaseFirst } from '@seedplanner/shared-utils';

export const formatStateOrStatus = (stateOrStatus: string) => stateOrStatus.split('_').map(upperCaseFirst).join(' ');
